<!--
 * @Date: 2020-05-12 16:34:12
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-20 14:31:46
 * @FilePath: /xy-pc/src/views/homelayout/news/newsdetail.vue
 -->
<template>
  <div>
    <div class="tabNav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="newsdetails">
      <h2 class="title">{{newsDetail.title}}</h2>
      <p class="creat-time">
        作者：{{newsDetail.author}}
        <span style="margin:0 10px"></span>
        发布时间：{{newsDetail.created_at}}
        <span style="margin:0 10px"></span>
        来源：{{newsDetail.source}}
      </p>

      <div   style="white-space: pre-line;text-align: left;" v-html="newsDetail.content" class="content ritchHtml"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newsdetails",

  props: {},
  data() {
    return {
      value: "",
      newsDetail: {
        id: "", //ID
        title: "", //标题
        thumbnail_image: "", //索引图像
        author: "", //作者
        source: "", //来源
        content: "", //内容
        created_at: "" //创建时间
      }
    };
  },
  created() {
    let newsId = this.$route.query.id;
    this.getNewsDetail(newsId);
  },
  computed: {},

  methods: {
    getNewsDetail(id) {
      this.$http({
        url: "api/v1/news/" + id,
        method: "get"
      }).then(res => {
        if (res.status == 200) {
          this.newsDetail = Object.assign({}, this.newsDetail, res.data.news);
        }else{
          this.$message.error(res.msg)
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tabNav {
  padding: 20px 0;
}
.newsdetails {
  padding-bottom: 100px;
  float: right;
  width: 100%;
  border-radius: 10px;
  box-sizing: border-box;
  .content {
   
  }
  .title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
  .creat-time {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
  .content {
    line-height: 30px;
  }
}
</style>